import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// SidebarRow , navigation row used inside the AdminSidebar v2 panel.
//
//   <SidebarRow icon={Mails} label="Newsletter" />
//   <SidebarRow icon={ThumbsUp} label="Abstimmungen" active />
//   <SidebarRow icon={LogOut}   label="Abmelden" danger />
//
// Idle rows are transparent (so the active row stands out). Active row gets
// the peach card treatment with orange-ink label + orange icon. Danger
// variant uses the red-soft hover (for Logout).
// ─────────────────────────────────────────────────────────────────────────────

export function SidebarRow({
  icon: Icon,
  label,
  active = false,
  danger = false,
  onClick,
  href,
  className = '',
}) {
  // Geometry mirrors AdminSidebar.v2.css exactly:
  //   padding: 7px 12px 7px 14px (asymmetric, label-leaning)
  //   border: 1px transparent (kept so active row's border doesn't bump layout)
  //   border-radius: 10px
  //   gap: 12px
  //   margin-bottom: 1px (rows hug each other)
  const base =
    'flex items-center gap-3 pl-3.5 pr-3 py-[7px] mb-px rounded-[10px] cursor-pointer text-[13px] ' +
    'border transition-colors no-underline w-full text-left'

  const variant = active
    ? 'bg-[#fff1e8] border-[rgba(232,93,31,0.30)] text-[#7a2b08] font-semibold ' +
      'shadow-[0_1px_2px_rgba(232,93,31,.04),0_6px_16px_-12px_rgba(232,93,31,.35)]'
    : danger
      ? 'bg-transparent border-transparent text-[#3a3733] font-medium hover:bg-[#fbeae6] hover:text-[#b3321c]'
      : 'bg-transparent border-transparent text-[#3a3733] font-medium hover:bg-[#f5f4f0] hover:text-[#1a1816]'

  const iconColor = active
    ? 'text-[#e85d1f]'
    : danger
      ? 'text-[#9a968e]'
      : 'text-[#6b6862]'

  const inner = (
    <>
      {Icon && <Icon size={18} strokeWidth={1.75} className={iconColor}/>}
      <span>{label}</span>
    </>
  )

  const finalClass = base + ' ' + variant + (className ? ' ' + className : '')

  if (href) {
    return (
      <a href={href} className={finalClass} onClick={onClick}>
        {inner}
      </a>
    )
  }
  return (
    <button type="button" className={finalClass} onClick={onClick}>
      {inner}
    </button>
  )
}

// SidebarCategory , groups SidebarRows with a small uppercase title and
// a darker divider above (except for the first group).
export function SidebarCategory({ title, first, children }) {
  return (
    <div className={'pt-2.5 ' + (first ? '' : 'mt-2.5 border-t border-[#d6d3cb]')}>
      {title && (
        <h3 className="m-0 px-3 mb-1 text-[10.5px] font-bold tracking-[0.10em] uppercase text-[#6b6862]">
          {title}
        </h3>
      )}
      <div className="space-y-0">
        {children}
      </div>
    </div>
  )
}
